import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { isAuthenticated, getUserRole } from './utils/auth';
import { GlobalPresenceProvider } from './components/GlobalPresenceProvider';
import WelcomePage from './pages/WelcomePage';
import LoginPage from './pages/LoginPage';
// RegisterPage disabled - using waitlist system
// import RegisterPage from './pages/RegisterPage';
import TeacherDashboard from './pages/TeacherDashboard';
import StudentView from './pages/StudentView';
import WhiteboardPage from './pages/WhiteboardPage';

// Protected route wrapper
function ProtectedRoute({ children, allowedRoles }) {
  if (!isAuthenticated()) {
    return <Navigate to="/welcome" replace />;
  }

  const userRole = getUserRole();
  if (allowedRoles && !allowedRoles.includes(userRole)) {
    return <Navigate to="/welcome" replace />;
  }

  return children;
}

// Redirect authenticated users away from public routes
function PublicRoute({ children }) {
  if (isAuthenticated()) {
    const role = getUserRole();
    if (role === 'teacher') {
      return <Navigate to="/teacher/dashboard" replace />;
    }
    return <Navigate to="/student/classes" replace />;
  }
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <GlobalPresenceProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/welcome" element={
          <PublicRoute>
            <WelcomePage />
          </PublicRoute>
        } />
        <Route path="/login" element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        } />
        {/* Registration disabled - using waitlist */}
        <Route path="/register" element={<Navigate to="/welcome" replace />} />

        {/* Teacher routes */}
        <Route
          path="/teacher/dashboard"
          element={
            <ProtectedRoute allowedRoles={['teacher']}>
              <TeacherDashboard />
            </ProtectedRoute>
          }
        />

        {/* Student routes */}
        <Route
          path="/student/classes"
          element={
            <ProtectedRoute allowedRoles={['student']}>
              <StudentView />
            </ProtectedRoute>
          }
        />

        <Route
          path="/whiteboard/:classId"
          element={
            <ProtectedRoute allowedRoles={['student']}>
              <WhiteboardPage />
            </ProtectedRoute>
          }
        />

        {/* Default redirect to welcome */}
        <Route path="/" element={<Navigate to="/welcome" replace />} />
        <Route path="*" element={<Navigate to="/welcome" replace />} />
      </Routes>
      </GlobalPresenceProvider>
    </BrowserRouter>
  );
}

export default App;
